import { render, staticRenderFns } from "./Student-Amount.vue?vue&type=template&id=42bf1c6a&scoped=true"
import script from "./Student-Amount.vue?vue&type=script&lang=js"
export * from "./Student-Amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf1c6a",
  null
  
)

export default component.exports